const ACTIVE_STATUS_LABEL = 'ATIVO'
const INACTIVE_STATUS_LABEL = 'INATIVO'

const documentationLinks = {
  ACTIVE_STATUS_LABEL,
  INACTIVE_STATUS_LABEL,
}

export default documentationLinks
